import CircleIcon from "@mui/icons-material/Circle";
import { Alert, Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { createMRTColumnHelper } from "material-react-table";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import { tenant } from "../../tenant";
import GenericForm from "../genericForm";
import GenericTable from "../genericTable";
// GraphQL import removed - now using REST API

function UserExternalEdit() {
	const [activeTab, setActiveTab] = useState(0);
	const { id } = useParams();
	const navigate = useNavigate();
	const columnHelper = createMRTColumnHelper();

	const handleChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	const authContext = useContext(AuthContext);
	const [personalData, setPersonalData] = useState({}); // Dati personali da query
	const [associatedAreaRolesData, setAssociatedAreaRolesData] = useState([]); // Dati delle aree associate
	const [contactsData, setContactsData] = useState([]); // Dati dei contatti
	const [showformAree, setShowFormAree] = useState(false);
	const [editAreaRole, setEditAreaRole] = useState(false);
	const [showFormContacts, setShowFormContacts] = useState(false);
	const [editContactsData, setEditContactsData] = useState({});
	const [editContacts, setEditContacts] = useState(false);
	const [editAreaRoleData, setEditAreaRoleData] = useState({});
	const [areeOption, setAreeOption] = useState([]);
	const [rolesOption, setRolesOption] = useState([]);
	const [contactsOption, setContactsOption] = useState([]);
	const [error, seterror] = useState("");

	function fetchPersonal() {
		apiService
			.get("/user-external-management/", { id: id }, {})
			.then((data) => {
				setPersonalData({ ...data, id: id });
			})
			.catch((error) => {
				toast.error(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00035",
					{ id: "user-external-edit-toast" }
				);
				// Se l'utente non esiste, reindirizza alla lista
				setTimeout(() => {
					const backPath = authContext.hasAuth("VIEW_SUPPLIER_EMPLOYEES") ? "/supplier-employees" : "/users-external-managment";
					navigate(backPath);
				}, 2000);
			});
	}

	function fetchAreaRoles() {
		apiService
			.get("/user-management/area-roles/", { id_user: id, internal: false }, {})
			.then((data) => {
				let new_data = [];
				for (let i = 0; i < data.length; i++) {
					let temp = {
						...data[i],
						roles: data[i].roles.join(", "), // Unisce gli elementi dell'array 'auths' in una stringa
					};
					new_data.push(temp);
				}
				setAssociatedAreaRolesData(new_data);
			})
			.catch((error) =>
				toast.error(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #00036",
					{ id: "user-external-edit-toast" }
				)
			);
	}

	function fetchContacts() {
		apiService
			.get("/user-management/contacts/", { id_user: id, internal: false }, {})
			.then((data) => {
				setContactsData(data);
			})
			.catch((error) =>
				toast.error(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #000037",
					{ id: "user-external-edit-toast" }
				)
			);
	}

	const [areeSelectedForm, setAreeSelectedForm] = useState([]);

	useEffect(() => {
		/*
		 * FETCH DELLE OPZIONI DELLE AUTOCOMPLETE
		 */
		if (localStorage.getItem("supplier")) {
			apiService
				.get("/suppliers-area-management/", { id_supplier: localStorage.getItem("supplier") }, {})
				.then((dataQuery) => {
					apiService
						.get("/area-management/", {}, {})
						.then((data) => {
							if (data) {
								let new_data = data.filter((item) => {
									return dataQuery.some((item2) => item.id === item2);
								});
								setAreeOption(new_data);
								if (dataQuery.length === 1) {
									setAreeSelectedForm(dataQuery[0]);
								}
							}
						})
						.catch((error) => {
							console.log(error);
							seterror(
								"Qualcosa è andato storto durante il caricamento delle autorizzazioni. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #00038"
							);
						});
				})
				.catch((error) =>
					seterror(
						"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #003139835"
					)
				);
		} else {
			apiService
				.get("/area-management/", {}, {})
				.then((data) => {
					if (data) {
						setAreeOption(data);
						setAreeSelectedForm(data[0].id);
					}
				})
				.catch((error) => {
					console.log(error);
					seterror(
						"Qualcosa è andato storto durante il caricamento delle autorizzazioni. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #00038"
					);
				});
		}
		apiService
			.get("/role-documents-management/", {}, {})
			.then((data) => {
				setRolesOption(data);
			})
			.catch((error) => {
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #003139835"
				);
			});
		apiService
			.get("/contacts/", {}, {})
			.then((data) => {
				setContactsOption(data);
			})
			.catch((error) =>
				seterror(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #0000391"
				)
			);
		/*
		 * FINE FETCH DELLE OPZIONI DELLE AUTOCOMPLE
		 */

		fetchPersonal();
		//fetchAreaRoles() -> Non lo chiamo qua perchè tanto lo chiamo sempre nello useEffect di showformAree, che all'inizio sarà sempre a false e quindi lo chiamo sempre
		// fetchContacts() -> come spiegato sopra
	}, []);

	const handleSavePersonalData = (data) => {
		console.log("Salva Dati Personali:", data);
	};

	async function deleteResource(params, endpoint) {
		try {
			// Parametri opzionali per la richiesta DELETE
			const headers = {}; // Headers opzionali

			// Esegui la chiamata DELETE
			const response = await apiService.delete(endpoint, params, headers);

			// Se arriviamo qui, la chiamata è andata a buon fine
			console.log(`Risorsa con id ${id} eliminata con successo:`, response);

			// Puoi fare qualcosa con la risposta, se necessario
			return response;
		} catch (error) {
			// Gestisci eventuali errori
			console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

			// Puoi gestire l'errore in modo specifico, ad esempio:
			if (error.message.includes("404")) {
				console.log(`La risorsa con id ${id} non è stata trovata`);
			} else if (error.message.includes("403")) {
				console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
			}

			// Rilancia l'errore se vuoi che venga gestito a un livello superiore
			throw error;
		}
	}

	function handleDelete(id, endpoint, resource, errorCode, sezione) {
		deleteResource(id, endpoint)
			.then((result) => {
				toast.success(`${resource} eliminato con successo`, { id: "user-external-edit-toast" });
				if (sezione === "area-roles") {
					fetchAreaRoles();
				} else if (sezione === "contacts") {
					fetchContacts();
				}
			})
			.catch((error) => {
				// Gestisci l'errore se non è stato gestito nella funzione
				toast.error(
					`Si è verificato un errore durante l'eliminazione del ${resource}. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #${errorCode}`,
					{ id: "user-external-edit-toast" }
				);
			});
	}

	const handleDeleteRow = (id_row, sezione) => {
		if (sezione === "area-roles") {
			handleDelete({ id_area: id_row, id_user: id, internal: false }, "/user-management/area-roles/", "area", "000345", sezione);
		} else if (sezione === "contacts") {
			handleDelete({ id_contact: id_row, id_user: id, internal: false }, "/user-management/contacts/", "contact", "000346", sezione);
		}
	};

	const handleEditRow = (id_row, sezione) => {
		if (sezione === "area-roles") {
			setEditAreaRole(true);
			apiService
				.get("/user-management/area-roles/", { id_user: id, id_area: id_row, internal: false }, {})
				.then((data) => {
					console.log("[UserExternalEdit] Area roles data received:", data);
					// Converti i ruoli da array di oggetti {id, name} a array di ID per il form
					const processedData = { ...data };
					if (processedData.roles && Array.isArray(processedData.roles)) {
						processedData.roles = processedData.roles.map((role) => {
							if (typeof role === "object" && role.id) {
								return role.id;
							}
							return role;
						});
					}
					console.log("[UserExternalEdit] Processed area roles data:", processedData);
					console.log("[UserExternalEdit] Roles array:", processedData.roles);
					setEditAreaRoleData(processedData);
					setShowFormAree(true);
				})
				.catch((error) =>
					seterror(
						"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #000369"
					)
				);
		} else if (sezione === "contacts") {
			setEditContacts(true);
			apiService
				.get("/user-management/contacts/", { id_user: id, id_contact: id_row, internal: false }, {})
				.then((data) => {
					setEditContactsData(data);
					setShowFormContacts(true);
				})
				.catch((error) =>
					seterror(
						"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #000381"
					)
				);
		}
	};

	useEffect(() => {
		if (!showformAree) fetchAreaRoles();
	}, [showformAree]);

	useEffect(() => {
		if (!showFormContacts) fetchContacts();
	}, [showFormContacts]);

	return (
		<DashboardLayout>
			{authContext.hasAuth("EDIT_EXTERNAL_USER") || authContext.hasAuth("EDIT_SUPPLIER_EMPLOYEES") ? (
				<>
					<DashboardNavbar />
					<Box sx={{ width: "100%" }}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => {
								const backPath = authContext.hasAuth("VIEW_SUPPLIER_EMPLOYEES")
									? "/supplier-employees"
									: "/users-external-managment";
								navigate(backPath);
							}}
							sx={{ mt: 2, alignSelf: "center", minWidth: "100px", color: "#ffffff", marginBottom: "30px" }}
						>
							Torna alla tabella operatori esterni
						</Button>
						<Tabs value={activeTab} onChange={handleChange} centered>
							<Tab label="Dati personali" />
							{personalData && personalData["is_admin"] === false && (
								<Tab
									label={
										<>
											<span>Aree associate</span>
											<span>
												{associatedAreaRolesData.length === 0 && (
													<CircleIcon
														color="error"
														fontSize={"small"}
														sx={{
															color: "#B71C1C",
															marginLeft: "10px",
															marginTop: "6px",
														}}
													/>
												)}
											</span>
										</>
									}
								/>
							)}
							<Tab
								label={
									<>
										<span>Contatti</span>
										<span>
											{contactsData.length === 0 && (
												<CircleIcon
													color="error"
													fontSize={"small"}
													sx={{
														color: "#B71C1C",
														marginLeft: "10px",
														marginTop: "6px",
													}}
												/>
											)}
										</span>
									</>
								}
							/>
						</Tabs>

						<TabPanel value={activeTab} index={0}>
							{(authContext.hasAuth("VIEW_EXTERNAL_USER") || authContext.hasAuth("VIEW_EXTERNAL_USER_ADMIN")) && (
								<GenericForm
									authModelName={
										authContext.hasAuth("VIEW_EXTERNAL_USER_ADMIN") ? "EXTERNAL_USER_ADMIN" : "EXTERNAL_USER"
									}
									old_data={personalData}
									url="/user-external-management/"
									useAPI={true} // cambia a true per usare l'API
									executeOnSuccess={true}
									executeOnSuccessTask={fetchPersonal}
									requiredFields={[
										{ name: "first_name", nameDisplayed: "Nome" },
										{ name: "last_name", nameDisplayed: "Cognome" },
										...(personalData && personalData["is_admin"] === false
											? [{ name: "fiscal_code", nameDisplayed: "Codice fiscale" }]
											: []),
										...(personalData && personalData["is_admin"] === false
											? [{ name: "date_of_birth", nameDisplayed: "Data di nascita" }]
											: []),
										// Email non più obbligatoria per dipendenti
									]}
									inputFields={[
										{
											type: "text",
											name: "first_name", // Nome nel DB
											label: "Nome", // Etichetta visibile
										},
										{
											type: "text",
											name: "last_name", // Cognome nel DB
											label: "Cognome", // Etichetta visibile
										},
										...(personalData && personalData["is_admin"] === false
											? [
													{
														type: "text",
														name: "fiscal_code", // Codice fiscale nel DB
														label: "Codice Fiscale", // Etichetta visibile
													},
												]
											: []),
										...(personalData && personalData["is_admin"] === false
											? [
													{
														type: "date",
														name: "date_of_birth", // Data di nascita nel DB
														label: "Data di Nascita", // Etichetta visibile
														helperText: "Formato gg-mm-aaaa",
													},
												]
											: []),
										...(personalData && personalData["is_admin"] === false
											? [
													{
														type: "email",
														name: "login_email", // Email nel DB
														label: "Email di login (non modificabile)", // Etichetta visibile
														disabled: true,
													},
												]
											: []),
									]}
								/>
							)}
						</TabPanel>

						{personalData && personalData["is_admin"] === false && (
							<TabPanel value={activeTab} index={1}>
								{authContext.hasAuth("ADD_USERROLEAUTHAREA") ||
								(authContext.hasAuth("EDIT_USERROLEAUTHAREA") && showformAree) ? (
									<center>
										{/* <Button
											variant="contained"
											color="info"
											onClick={() => {
												setShowFormAree(!showformAree);
												setEditAreaRole(false);
											}}
											sx={{
												mt: 2,
												alignSelf: "center",
												minWidth: "100px",
												color: "#000000",
												marginBottom: "30px",
												marginTop: "20px",
											}}
										>
											{showformAree ? "Torna alla tabella" : "Aggiungi"}
										</Button> */}
									</center>
								) : null}
								{error !== "" ? (
									<Alert severity="error">{error}</Alert>
								) : !showformAree ? (
									<GenericTable
										authModelName={"USERROLEAUTHAREA"}
										columns={[
											columnHelper.accessor("area_name", {
												header: "Area",
												size: 120,
											}),
											columnHelper.accessor("roles", {
												header: "Ruoli",
												size: 350,
												cell: (info) => {
													const words = info.getValue().split(/(?=[A-Z])/); // Separazione basata su maiuscole per "diodiavolo" -> ["dio", "diavolo"]
													return words.join(", "); // Unisce le parole con una virgola
												},
											}),
										]}
										data={associatedAreaRolesData}
										onDelete={(id) => handleDeleteRow(id, "area-roles")}
										onEdit={(id) => handleEditRow(id, "area-roles")}
									/>
								) : !editAreaRole ? (
									<GenericForm
										authModelName={"USERROLEAUTHAREA"}
										formData={{ id_user: id, internal: false, area: areeSelectedForm }}
										url="/user-management/area-roles/"
										showErrorFromAPI={true}
										useAPI={true}
										requiredFields={[
											{ name: "area", nameDiplayed: "area" },
											{
												name: "roles",
												nameDiplayed: "ruoli associati",
											},
										]}
										inputFields={[
											{
												type: "autocomplete",
												name: "area", // Nome nel DB
												label: "Area", // Etichetta visibile
												options: areeOption,
												valueToDisplay: (value, options) => {
													// Controlla se `value` è un oggetto
													if (typeof value === "object") {
														return `${value.name}`; // Mostra direttamente le informazioni
													}
													// Se `value` è un ID (numero)
													const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
													return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
												},

												valueToSave: (selected) => {
													// Se `selected` è un array
													if (Array.isArray(selected)) {
														// Crea un insieme di ID esistenti per evitare duplicati
														const existingIds = new Set(
															selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
														);

														// Aggiungi il nuovo ID solo se non è già presente
														return Array.from(existingIds);
													}

													// Se `selected` è un singolo oggetto, restituisci il suo ID
													return selected?.id;
												},
												valueComparator: (option, value) => {
													// Controlla se `value` è un numero (ID)
													if (typeof value === "number") {
														return option.id === value; // Confronta l'ID dell'opzione con il valore
													}

													// Se `value` è un oggetto, confronta l'ID
													return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
												},
											},
											{
												type: "autocomplete",
												name: "roles", // Nome nel DB
												label: "Ruoli associati", // Etichetta visibile
												multiple: true,
												options: rolesOption,
												valueToDisplay: (value, options) => {
													// Controlla se `value` è un oggetto
													if (typeof value === "object") {
														return `${value.name}`; // Mostra direttamente le informazioni
													}
													// Se `value` è un ID (numero)
													const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
													return option ? `${option.name}` : "ruolo non trovato"; // Messaggio se non trovato
												},

												valueToSave: (selected) => {
													// Se `selected` è un array
													if (Array.isArray(selected)) {
														// Crea un insieme di ID esistenti per evitare duplicati
														const existingIds = new Set(
															selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
														);

														// Aggiungi il nuovo ID solo se non è già presente
														return Array.from(existingIds);
													}

													// Se `selected` è un singolo oggetto, restituisci il suo ID
													return selected?.id;
												},
												valueComparator: (option, value) => {
													// Controlla se `value` è un numero (ID)
													if (typeof value === "number") {
														return option.id === value; // Confronta l'ID dell'opzione con il valore
													}

													// Se `value` è un oggetto, confronta l'ID
													return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
												},
											},
										]}
									/>
								) : (
									(() => {
										const formOldData = { ...editAreaRoleData, id_user: id, internal: false };
										console.log("[UserExternalEdit] Rendering GenericForm with old_data:", formOldData);
										console.log("[UserExternalEdit] rolesOption available:", rolesOption.length);
										return (
											<GenericForm
												authModelName={"USERROLEAUTHAREA"}
												old_data={formOldData}
												url="/user-management/area-roles/"
												useAPI={true}
												key={`edit-area-role-${editAreaRoleData?.area || "new"}-${editAreaRoleData?.roles?.length || 0}`}
												requiredFields={[
													{ name: "area", nameDiplayed: "area" },
													{
														name: "roles",
														nameDiplayed: "ruoli associati",
													},
												]}
												inputFields={[
													{
														type: "autocomplete",
														name: "area", // Nome nel DB
														label: "Area", // Etichetta visibile
														options: areeOption,
														valueToDisplay: (value, options) => {
															// Controlla se `value` è un oggetto
															if (typeof value === "object") {
																return `${value.name}`; // Mostra direttamente le informazioni
															}
															// Se `value` è un ID (numero)
															const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
															return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
														},

														valueToSave: (selected) => {
															// Se `selected` è un array
															if (Array.isArray(selected)) {
																// Crea un insieme di ID esistenti per evitare duplicati
																const existingIds = new Set(
																	selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
																);

																// Aggiungi il nuovo ID solo se non è già presente
																return Array.from(existingIds);
															}

															// Se `selected` è un singolo oggetto, restituisci il suo ID
															return selected?.id;
														},
														valueComparator: (option, value) => {
															// Controlla se `value` è un numero (ID)
															if (typeof value === "number") {
																return option.id === value; // Confronta l'ID dell'opzione con il valore
															}

															// Se `value` è un oggetto, confronta l'ID
															return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
														},
													},
													{
														type: "autocomplete",
														name: "roles", // Nome nel DB
														label: "Ruoli associati", // Etichetta visibile
														multiple: true,
														options: rolesOption,
														valueToDisplay: (value, options) => {
															// Controlla se `value` è un oggetto
															if (typeof value === "object") {
																return `${value.name}`; // Mostra direttamente le informazioni
															}
															// Se `value` è un ID (numero)
															const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
															return option ? `${option.name}` : "ruolo non trovato"; // Messaggio se non trovato
														},

														valueToSave: (selected) => {
															// Se `selected` è un array
															if (Array.isArray(selected)) {
																// Crea un insieme di ID esistenti per evitare duplicati
																const existingIds = new Set(
																	selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
																);

																// Aggiungi il nuovo ID solo se non è già presente
																return Array.from(existingIds);
															}

															// Se `selected` è un singolo oggetto, restituisci il suo ID
															return selected?.id;
														},
														valueComparator: (option, value) => {
															// Controlla se `value` è un numero (ID)
															if (typeof value === "number") {
																return option.id === value; // Confronta l'ID dell'opzione con il valore
															}

															// Se `value` è un oggetto, confronta l'ID
															return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
														},
													},
												]}
											/>
										);
									})()
								)}
							</TabPanel>
						)}

						<TabPanel value={activeTab} index={personalData && personalData["is_admin"] ? 1 : 2}>
							{authContext.hasAuth("ADD_USERCONTACT") || (authContext.hasAuth("EDIT_USERCONTACT") && showFormContacts) ? (
								<center>
									<Button
										variant="contained"
										color="info"
										onClick={() => {
											setShowFormContacts(!showFormContacts);
											setEditContacts(false);
										}}
										sx={{
											mt: 2,
											alignSelf: "center",
											minWidth: "100px",
											color: "#000000",
											marginBottom: "30px",
											marginTop: "20px",
										}}
									>
										{showFormContacts ? "Torna alla tabella" : "Aggiungi"}
									</Button>
								</center>
							) : null}
							{error !== "" ? (
								<Alert severity="error">{error}</Alert>
							) : !showFormContacts ? (
								<GenericTable
									authModelName={"USERCONTACT"}
									columns={[
										columnHelper.accessor("contact_type", {
											header: "Tipo contatto",
											size: 120,
										}),
										columnHelper.accessor("contact_value", {
											header: "Valore contatto",
											size: 120,
										}),
									]}
									data={contactsData}
									onDelete={(id) => handleDeleteRow(id, "contacts")}
									onEdit={(id) => handleEditRow(id, "contacts")}
								/>
							) : !editContacts ? (
								<GenericForm
									authModelName={"USERCONTACT"}
									old_data={{ id_user: id, internal: false }}
									url="/user-management/contacts/"
									useAPI={true}
									requiredFields={[
										{ name: "contact_type", nameDiplayed: "Tipologia del contatto" },
										{
											name: "contact_value",
											nameDiplayed: "Valore del contatto",
										},
									]}
									inputFields={[
										{
											type: "autocomplete",
											name: "contact_type", // Nome nel DB
											label: "Tipologia del contatto", // Etichetta visibile
											options: contactsOption,
											valueToDisplay: (value, options) => {
												// Controlla se `value` è un oggetto
												if (typeof value === "object") {
													return `${value.name}`; // Mostra direttamente le informazioni
												}
												// Se `value` è un ID (numero)
												const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
												return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
											},

											valueToSave: (selected) => {
												// Se `selected` è un array
												if (Array.isArray(selected)) {
													// Crea un insieme di ID esistenti per evitare duplicati
													const existingIds = new Set(
														selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
													);

													// Aggiungi il nuovo ID solo se non è già presente
													return Array.from(existingIds);
												}

												// Se `selected` è un singolo oggetto, restituisci il suo ID
												return selected?.id;
											},
											valueComparator: (option, value) => {
												// Controlla se `value` è un numero (ID)
												if (typeof value === "number") {
													return option.id === value; // Confronta l'ID dell'opzione con il valore
												}

												// Se `value` è un oggetto, confronta l'ID
												return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
											},
										},
										{
											type: "text",
											name: "contact_value", // Nome nel DB
											label: "Valore del contatto", // Etichetta visibile
										},
									]}
								/>
							) : (
								<GenericForm
									authModelName={"USERCONTACT"}
									old_data={{ ...editContactsData, id_user: id, internal: false }}
									url="/user-management/contacts/"
									useAPI={true}
									requiredFields={[
										{ name: "contact_type", nameDiplayed: "Tipologia del contatto" },
										{
											name: "contact_value",
											nameDiplayed: "Valore del contatto",
										},
									]}
									inputFields={[
										{
											type: "autocomplete",
											name: "contact_type", // Nome nel DB
											label: "Tipologia del contatto", // Etichetta visibile
											options: contactsOption,
											valueToDisplay: (value, options) => {
												// Controlla se `value` è un oggetto
												if (typeof value === "object") {
													return `${value.name}`; // Mostra direttamente le informazioni
												}
												// Se `value` è un ID (numero)
												const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
												return option ? `${option.name}` : "area non trovata"; // Messaggio se non trovato
											},

											valueToSave: (selected) => {
												// Se `selected` è un array
												if (Array.isArray(selected)) {
													// Crea un insieme di ID esistenti per evitare duplicati
													const existingIds = new Set(
														selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
													);

													// Aggiungi il nuovo ID solo se non è già presente
													return Array.from(existingIds);
												}

												// Se `selected` è un singolo oggetto, restituisci il suo ID
												return selected?.id;
											},
											valueComparator: (option, value) => {
												// Controlla se `value` è un numero (ID)
												if (typeof value === "number") {
													return option.id === value; // Confronta l'ID dell'opzione con il valore
												}

												// Se `value` è un oggetto, confronta l'ID
												return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
											},
										},
										{
											type: "text",
											name: "contact_value", // Nome nel DB
											label: "Valore del contatto", // Etichetta visibile
										},
									]}
								/>
							)}
						</TabPanel>
					</Box>
				</>
			) : (
				<MDAlert color="error" dismissible>
					<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
				</MDAlert>
			)}
		</DashboardLayout>
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography component="div">{children}</Typography>
				</Box>
			)}
		</div>
	);
}

export default UserExternalEdit;
